import { useRef } from "react";
import { useDispatch } from "react-redux";
import { reactivateCustomer } from "../../../redux/slice/customer/customerSlice";

const ReactivateCustomer = ({id}) => {

    const closeRef = useRef();
    const dispatch = useDispatch()

  return (
    <div className='container'>
    <div className='my-3 text-center'>
      <h3 className='text-dark fs-4'>Reactivate Customer</h3>
      <p className='lh-sm fs-6'>
        Are you sure you want to reactivate this customer
      </p>
    </div>
    <div className='d-flex justify-content-between'>
          <div className='d-grid'>
            <button
              ref={closeRef}
              className='btn btn-sm mt-2 px-3 text-muted'
              data-bs-dismiss='modal'
              style={{ background: "#F1F0F1" }}
            >
              Cancel
            </button>
          </div>
          <div className='d-grid'>
            <button
              onClick={() => {
                dispatch(reactivateCustomer(id))
                closeRef.current.click()
            }}
              className='btn btn-success btn-sm mt-2 px-3 text-white'
            >
              Reactivate
            </button>
          </div>
        </div>
  </div>
  )
}

export default ReactivateCustomer